import { Translation } from '@ps/web-shared-components';
import React from 'react';

import type { OnboardingInfo } from '@swf/components/Onboarding/OnboardingContext/OnbordingContext';

import {
  TXTCLI_Choose_how_much_you_would_like_ELL,
  TXTCLI_Choose_the_type_of_game_you_wo_ELL,
  TXTCLI_Click_here_to_learn_more_about_ELL_2,
  TXTCLI_Click_here_to_see_available_pr_ELL,
  TXTCLI_Learn_How_to_Play,
  TXTCLI_LetXs_Play,
  TXTCLI_Once_youXve_made_your_selectio_ELL,
  TXTCLI_Prize_X_Game_Information,
  TXTCLI_Select_Buy_In,
  TXTCLI_Select_Game_Type
} from './onboarding.messages.json';

export const ONBOARDING_STEPS: OnboardingInfo<JSX.Element>[] = [
  {
    id: 'tour-sag-1',
    heading: <Translation {...TXTCLI_Select_Game_Type} tagName="span" />,
    context: <Translation {...TXTCLI_Choose_the_type_of_game_you_wo_ELL} tagName="span" />,
    placement: 'bottom'
  },
  {
    id: 'tour-sag-2',
    heading: <Translation {...TXTCLI_Select_Buy_In} tagName="span" />,
    context: <Translation {...TXTCLI_Choose_how_much_you_would_like_ELL} tagName="span" />,
    placement: 'right'
  },
  {
    id: 'tour-sag-3',
    heading: <Translation {...TXTCLI_Prize_X_Game_Information} tagName="span" />,
    context: <Translation {...TXTCLI_Click_here_to_see_available_pr_ELL} tagName="span" />,
    placement: 'right'
  },
  {
    id: 'tour-sag-4',
    heading: <Translation {...TXTCLI_Learn_How_to_Play} tagName="span" />,
    context: <Translation {...TXTCLI_Click_here_to_learn_more_about_ELL_2} tagName="span" />,
    placement: 'left'
  },
  {
    id: 'tour-sag-5',
    heading: <Translation {...TXTCLI_LetXs_Play} tagName="span" />,
    context: <Translation {...TXTCLI_Once_youXve_made_your_selectio_ELL} tagName="span" />,
    placement: 'left'
  }
];
